// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1Gl7t","box":"WorkspacesBox_box__3L-Gn","node":"WorkspacesBox_node__2KUfb"};